<template>
  <div>
    <div class="home-bg"></div>
    <div class="container">
      <div class="title-frame">
        <h1 class="title">Tokoyami Towa <br v-if="this.shortMode">Song Database</h1>
        <p class="description">{{ $t('description') }}</p>
        <p class="song-stats">{{ $t('songStats', {
          total: config.songs.length, original: originalSongCount, cover:
            coverSongCount
        }) }}</p>
        <div class="btn-container">
          <router-link to="/timeline" class="btn">{{ $t('link.timeline') }}</router-link>
          <!-- <router-link to="/search" class="btn">{{ $t('search') }}</router-link> -->
        </div>
      </div>
      <div class="category-container">
        <div class="category-title">{{ $t('quickAccess') }}</div>
        <div class="category-flex-container">
          <template v-for="(release, index) in releases" :key="index">
            <router-link v-if="release.isShow" :to="`/view?t=${release.name}`" class="category-card">
              <img :src="release.artworkUrl" />
              <p class="category-name">{{ release.name }}</p>
              <p class="category-description">{{ release.description }} - {{ release.releaseDate }}</p>
            </router-link>
          </template>
          <router-link :to="`/view?t=breakyourxxx`" class="category-card">
            <img src="https://hololive.hololivepro.com/wp-content/uploads/2023/07/230723_sub1.png" />
            <p class="category-name">Break your XXX</p>
            <p class="category-description">Tokoyami Towa 1st solo Live</p>
          </router-link>
          <router-link :to="`/view?t=shinier`" class="category-card">
            <img src="https://hololive.hololivepro.com/wp-content/uploads/2025/08/SHINier-KV-2048x1152.webp" />
            <p class="category-name">SHINier</p>
            <p class="category-description">Tokoyami Towa 2nd Live</p>
          </router-link>
          <router-link to="/view?t=cover" class="category-card">
            <div class="galary">
              <img v-for="(image, index) in coverSongArtworks()" :key="index" :src="image" />
            </div>
            <p class="category-name">カバー楽曲</p>
            <p class="category-description">Cover songs</p>
          </router-link>
          <router-link to="/view?t=original" class="category-card">
            <div class="galary">
              <img v-for="(image, index) in originalSongArtworks()" :key="index" :src="image" />
            </div>
            <p class="category-name">オリジナル楽曲<br />（すべて）</p>
            <p class="category-description">Original songs</p>
          </router-link>
          <router-link to="/view?t=original-with-mv" class="category-card">
            <div class="galary">
              <img v-for="(image, index) in originalSongWithMVArtworks()" :key="index" :src="image" />
            </div>
            <p class="category-name">オリジナル楽曲<br />（MV有）</p>
            <p class="category-description">Original songs (with MV)</p>
          </router-link>
        </div>
      </div>
      <div class="songs-container">
        <div class="category-title">{{ $t('allSongs') }}</div>
        <div class="category-flex-container">
          <div v-for="(song, index) in displaySongs" :key="song.youtubeId" class="song-card-wrapper"
            :data-index="index">
            <VideoCard v-if="visibleMap[index]" :song="song" />
            <div v-else class="song-card-placeholder"></div>
          </div>
        </div>
        <div class="category-showmore">
          <button v-if="displaySongs.length < config.songs.length" @click="onClickShowMore" class="showmore-button">{{
            $t('showMore') }}</button>
        </div>
      </div>

      <div class="links-container">
        <div class="title">{{ $t('linksTitle') }}</div>
        <div class="links-list">
          <a href="https://www.youtube.com/@TokoyamiTowa" target="_blank" rel="noopener noreferrer" class="link yt">
            <img height="24" width="24" src="https://cdn.simpleicons.org/youtube/ffffff" />
            <span>YouTube</span>
          </a>
          <a href="https://x.com/tokoyamitowa" target="_blank" rel="noopener noreferrer" class="link twitter">
            <img height="20" width="20" src="https://cdn.simpleicons.org/x/ffffff" />
            <span>X (Twitter)</span>
          </a>
          <a href="https://www.twitch.tv/tokoyamitowa_holo" target="_blank" rel="noopener noreferrer"
            class="link twitch">
            <img height="20" width="20" src="https://cdn.simpleicons.org/twitch/ffffff" />
            <span>Twitch</span>
          </a>
          <a href="https://hololive.hololivepro.com/talents/tokoyami-towa/" target="_blank" rel="noopener noreferrer"
            class="link official">
            <span class="pi pi-link th-icon" :style="{ fontSize: '20px' }"></span>
            <span>hololive Official</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import VideoCard from '@/components/VideoCard.vue';
import config from '../assets/data/songs.js'
import releases from '../assets/data/releases.js';

export default {
  name: 'HomeView',
  data() {
    return {
      config: config,
      releases: releases.releases,
      displaySongs: config.songs.slice(0, 16),
      visibleMap: {},
      shortMode: window.innerWidth <= 600,
    }
  },
  computed: {
    originalSongCount() {
      return this.config.songs.filter(s => s.type === 'original').length
    },
    coverSongCount() {
      return this.config.songs.filter(s => s.type === 'cover').length
    }
  },
  components: {
    VideoCard
  },
  mounted() {
    const localeMap = { ja_JP: 'ja', en_US: 'en', kr_KR: 'kr' }
    const key = localeMap[this.$i18n.locale] || 'ja'
    document.title = config.siteTitle[key]
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index)
            this.visibleMap = { ...this.visibleMap, [index]: true }
            observer.unobserve(entry.target)
          }
        })
      },
      { rootMargin: '0px 0px 200px 0px' }
    )
    this._observer = observer
    this.$nextTick(() => {
      this.$el.querySelectorAll('.song-card-wrapper').forEach(el => observer.observe(el))
    })
    //
    window.addEventListener('resize', this.handleResize)
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    if (this._observer) this._observer.disconnect()
  },
  methods: {
    originalSongArtworks() {
      var images = []
      var usedReleases = []
      for (const song of this.config.songs) {
        if (song.type === 'original' && !song.isAvailableMV && !song.release.some(r => usedReleases.includes(r)) && song.singers.length === 1) {
          images.push(song.thumbnailUrl)
          song.release.forEach(r => usedReleases.push(r))
        }
        if (images.length >= 4) break
      }
      return images
    },
    originalSongWithMVArtworks() {
      var images = []
      for (const song of this.config.songs) {
        if (song.type === 'original' && song.isAvailableMV) {
          images.push(song.thumbnailUrl)
        }
        if (images.length >= 4) break
      }
      return images
    },
    coverSongArtworks() {
      var images = []
      for (const song of this.config.songs) {
        if (song.type === 'cover') {
          images.push(song.thumbnailUrl)
        }
        if (images.length >= 4) break
      }
      return images
    },
    onClickShowMore() {
      this.displaySongs = this.config.songs.slice(0, this.displaySongs.length + 16)
      this.$nextTick(() => {
        this.$el.querySelectorAll('.song-card-wrapper').forEach(el => this._observer.observe(el))
      })
    },
    handleResize: function () {
      if (window.innerWidth <= 600) {
        this.shortMode = true
      } else {
        this.shortMode = false
      }
    }
  }
}
</script>

<style scoped>
.home-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: var(--home-bg-gradient);
  background-size: 400% 400%;
  animation: wave-bg 10s ease infinite;
}

@keyframes wave-bg {
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.container {
  max-width: 1112px;
  margin: 0 auto;
  padding: 2rem;
}

.title-frame {
  margin: 96px auto 120px auto;
  text-align: center;
}

.title-frame .title {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.title-frame .btn-container {
  margin-top: 48px;
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
}

/* Navigation buttons - equal weight, filled style in both themes */
.title-frame .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #b06fce;
  color: #ffffff;
  border: 2px solid #b06fce;
  padding: 0 32px;
  height: 48px;
  min-width: 160px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  border-radius: 4px;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
  text-decoration: none;
}

.title-frame .btn:hover {
  background: #9d59bd;
  border-color: #9d59bd;
  color: #ffffff;
}

/* Dark theme overrides */
:root[data-theme='dark'] .title-frame .btn {
  background: #8447a0;
  color: #ffffff;
  border-color: #8447a0;
}

:root[data-theme='dark'] .title-frame .btn:hover {
  background: #9a58b8;
  border-color: #9a58b8;
  color: #ffffff;
}

.description {
  font-size: 1rem;
  line-height: 1.5;
}

.song-stats {
  font-size: 0.85rem;
  color: var(--color-text-secondary);
  margin-top: 0.5rem;
}

.category-container {
  margin: 24px auto;
}

.category-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.category-flex-container {
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
  gap: 16px;
}

.category-card {
  background-color: var(--color-surface);
  text-decoration: none;
  width: calc(20% - 13px);
  height: 100%;
  color: var(--color-text-primary);
  border-radius: 8px;
  transition: transform 0.15s, box-shadow 0.15s;
  box-shadow: 0 2px 4px var(--color-shadow), inset 0 0 0 0px var(--color-primary);
}

.category-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 2px 4px var(--color-shadow), inset 0 0 0 1px var(--color-primary);
}

.category-card img {
  width: 100%;
  height: auto;
  aspect-ratio: 1;
  object-fit: cover;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: block;
}

.category-showmore {
  margin: 16px auto;
  display: flex;
  justify-content: center;
}

.category-showmore button {
  background-color: transparent;
  color: var(--color-accent);
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 0.9rem;
  margin: 0 auto;
  ;
}

.galary {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.galary img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  aspect-ratio: 1;
  border-radius: 0;
}

.galary img:nth-child(1) {
  border-top-left-radius: 8px;
}

.galary img:nth-child(2) {
  border-top-right-radius: 8px;
}

.category-name {
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0.5rem 0 0 0.5rem;
}

.category-description {
  font-size: 0.8rem;
  margin: 0 0.5rem 12px 0.5rem;
  color: var(--color-text-secondary);
}

.songs-container {
  margin: 64px auto 24px auto;
}

.song-card-wrapper {
  width: calc(25% - 12px);
}

.song-card-placeholder {
  width: 250px;
  height: 200px;
  border-radius: 8px;
  background-color: var(--color-surface);
}

.links-container {
  margin: 64px auto 128px auto;
  text-align: center;
}

.links-container .title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 32px;
}

.links-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.links-container .link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 280px;
  height: 52px;
  border-radius: 26px;
  text-decoration: none;
  color: white;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.03em;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.links-container .link:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.22);
}

.links-container .yt {
  background-color: #ff0033;
}

.links-container .twitter {
  background-color: #000000;
}

.links-container .twitch {
  background-color: #9146ff;
}

.links-container .official {
  background: linear-gradient(135deg, #27C7FF, #009ec4);
}

@media (max-width: 1000px) {
  .category-card {
    width: calc(25% - 12px);
  }

  .song-card-wrapper {
    width: calc(33% - 9px);
  }
}

@media (max-width: 800px) {
  .category-card {
    width: calc(33% - 9px);
  }

  .song-card-wrapper {
    width: calc(50% - 8px);
  }
}

@media (max-width: 600px) {
  .container {
    padding: 1rem;
  }

  .title-frame {
    margin: 48px auto 72px auto;
  }

  .title-frame .title {
    font-size: 2.0rem;
  }

  .category-flex-container {
    gap: 12px;
    justify-content: space-between;
    width: 100%;
  }

  .category-card {
    width: calc(50% - 6px);
  }

  .song-card-wrapper {
    width: 100%;
  }

  .song-card-placeholder {
    width: 100%;
    height: 170px;
  }
}
</style>